export const mesoregioesSelect = [
    { label: 'CAMPO DAS VERTENTES', value: 'CAMPO DAS VERTENTES' },
    { label: 'CENTRAL MINEIRA', value: 'CENTRAL MINEIRA' },
    { label: 'JEQUITINHONHA', value: 'JEQUITINHONHA' },
    { label: 'METROPOLITANA DE BELO HORIZONTE', value: 'METROPOLITANA DE BELO HORIZONTE' },
    { label: 'NOROESTE DE MINAS', value: 'NOROESTE DE MINAS' },
    { label: 'NORTE DE MINAS', value: 'NORTE DE MINAS' },
    { label: 'OESTE DE MINAS', value: 'OESTE DE MINAS' },
    { label: 'SUL/SUDOESTE DE MINAS', value: 'SUL/SUDOESTE DE MINAS' },
    { label: 'TRIANGULO MINEIRO/ALTO PARANAIBA', value: 'TRIANGULO MINEIRO/ALTO PARANAIBA' },
    { label: 'VALE DO MUCURI', value: 'VALE DO MUCURI' },
    { label: 'VALE DO RIO DOCE', value: 'VALE DO RIO DOCE' },
    { label: 'ZONA DA MATA', value: 'ZONA DA MATA' },
];

export const microregioesSelect = [
    { label: 'AIMORES', value: 'AIMORES' },
    { label: 'ALFENAS', value: 'ALFENAS' },
    { label: 'ALMENARA', value: 'ALMENARA' },
    { label: 'ANDRELANDIA', value: 'ANDRELANDIA' },
    { label: 'ARACUAI', value: 'ARACUAI' },
    { label: 'ARAXA', value: 'ARAXA' },
    { label: 'BARBACENA', value: 'BARBACENA' },
    { label: 'BELO HORIZONTE', value: 'BELO HORIZONTE' },
    { label: 'BOCAIUVA', value: 'BOCAIUVA' },
    { label: 'BOM DESPACHO', value: 'BOM DESPACHO' },
    { label: 'CAMPO BELO', value: 'CAMPO BELO' },
    { label: 'CAPELINHA', value: 'CAPELINHA' },
    { label: 'CARATINGA', value: 'CARATINGA' },
    { label: 'CATAGUASES', value: 'CATAGUASES' },
    { label: 'CONCEICAO DO MATO DENTRO', value: 'CONCEICAO DO MATO DENTRO' },
    { label: 'CONSELHEIRO LAFAIETE', value: 'CONSELHEIRO LAFAIETE' },
    { label: 'CURVELO', value: 'CURVELO' },
    { label: 'DIAMANTINA', value: 'DIAMANTINA' },
    { label: 'DIVINOPOLIS', value: 'DIVINOPOLIS' },
    { label: 'FORMIGA', value: 'FORMIGA' },
    { label: 'FRUTAL', value: 'FRUTAL' },
    { label: 'GOVERNADOR VALADARES', value: 'GOVERNADOR VALADARES' },
    { label: 'GRAO MOGOL', value: 'GRAO MOGOL' },
    { label: 'GUANHAES', value: 'GUANHAES' },
    { label: 'IPATINGA', value: 'IPATINGA' },
    { label: 'ITABIRA', value: 'ITABIRA' },
    { label: 'ITAGUARA', value: 'ITAGUARA' },
    { label: 'ITAJUBA', value: 'ITAJUBA' },
    { label: 'ITUIUTABA', value: 'ITUIUTABA' },
    { label: 'JANAUBA', value: 'JANAUBA' },
    { label: 'JANUARIA', value: 'JANUARIA' },
    { label: 'JUIZ DE FORA', value: 'JUIZ DE FORA' },
    { label: 'LAVRAS', value: 'LAVRAS' },
    { label: 'MANHUACU', value: 'MANHUACU' },
    { label: 'MANTENA', value: 'MANTENA' },
    { label: 'MONTES CLAROS', value: 'MONTES CLAROS' },
    { label: 'MURIAE', value: 'MURIAE' },
    { label: 'NANUQUE', value: 'NANUQUE' },
    { label: 'OLIVEIRA', value: 'OLIVEIRA' },
    { label: 'OURO PRETO', value: 'OURO PRETO' },
    { label: 'PARA DE MINAS', value: 'PARA DE MINAS' },
    { label: 'PARACATU', value: 'PARACATU' },
    { label: 'PASSOS', value: 'PASSOS' },
    { label: 'PATOS DE MINAS', value: 'PATOS DE MINAS' },
    { label: 'PATROCINIO', value: 'PATROCINIO' },
    { label: 'PECANHA', value: 'PECANHA' },
    { label: 'PEDRA AZUL', value: 'PEDRA AZUL' },
    { label: 'PIRAPORA', value: 'PIRAPORA' },
    { label: 'PIUI', value: 'PIUI' },
    { label: 'POCOS DE CALDAS', value: 'POCOS DE CALDAS' },
    { label: 'PONTE NOVA', value: 'PONTE NOVA' },
    { label: 'POUSO ALEGRE', value: 'POUSO ALEGRE' },
    { label: 'SALINAS', value: 'SALINAS' },
    { label: 'SANTA RITA DO SAPUCAI', value: 'SANTA RITA DO SAPUCAI' },
    { label: 'SAO JOAO DEL REI', value: 'SAO JOAO DEL REI' },
    { label: 'SAO LOURENCO', value: 'SAO LOURENCO' },
    { label: 'SAO SEBASTIAO DO PARAISO', value: 'SAO SEBASTIAO DO PARAISO' },
    { label: 'SETE LAGOAS', value: 'SETE LAGOAS' },
    { label: 'TEOFILO OTONI', value: 'TEOFILO OTONI' },
    { label: 'TRES MARIAS', value: 'TRES MARIAS' },
    { label: 'UBA', value: 'UBA' },
    { label: 'UBERABA', value: 'UBERABA' },
    { label: 'UBERLANDIA', value: 'UBERLANDIA' },
    { label: 'UNAI', value: 'UNAI' },
    { label: 'VARGINHA', value: 'VARGINHA' },
    { label: 'VICOSA', value: 'VICOSA' },
];

export const comarcasSelect = [
    { label: 'ABAETE', value: 'ABAETE' },
    { label: 'ABRE CAMPO', value: 'ABRE CAMPO' },
    { label: 'ACUCENA', value: 'ACUCENA' },
    { label: 'AGUAS FORMOSAS', value: 'AGUAS FORMOSAS' },
    { label: 'AIMORES', value: 'AIMORES' },
    { label: 'AIURUOCA', value: 'AIURUOCA' },
    { label: 'ALEM PARAIBA', value: 'ALEM PARAIBA' },
    { label: 'ALFENAS', value: 'ALFENAS' },
    { label: 'ALMENARA', value: 'ALMENARA' },
    { label: 'ALPINOPOLIS', value: 'ALPINOPOLIS' },
    { label: 'ALTO RIO DOCE', value: 'ALTO RIO DOCE' },
    { label: 'ALVINOPOLIS', value: 'ALVINOPOLIS' },
    { label: 'ANDRADAS', value: 'ANDRADAS' },
    { label: 'ANDRELANDIA', value: 'ANDRELANDIA' },
    { label: 'ARACUAI', value: 'ARACUAI' },
    { label: 'ARAGUARI', value: 'ARAGUARI' },
    { label: 'ARAXA', value: 'ARAXA' },
    { label: 'ARCOS', value: 'ARCOS' },
    { label: 'AREADO', value: 'AREADO' },
    { label: 'ARINOS', value: 'ARINOS' },
    { label: 'BAEPENDI', value: 'BAEPENDI' },
    { label: 'BAMBUI', value: 'BAMBUI' },
    { label: 'BARAO DE COCAIS', value: 'BARAO DE COCAIS' },
    { label: 'BARBACENA', value: 'BARBACENA' },
    { label: 'BARROSO', value: 'BARROSO' },
    { label: 'BELO HORIZONTE', value: 'BELO HORIZONTE' },
    { label: 'BELO VALE', value: 'BELO VALE' },
    { label: 'BETIM', value: 'BETIM' },
    { label: 'BICAS', value: 'BICAS' },
    { label: 'BOA ESPERANCA', value: 'BOA ESPERANCA' },
    { label: 'BOCAIUVA', value: 'BOCAIUVA' },
    { label: 'BOM DESPACHO', value: 'BOM DESPACHO' },
    { label: 'BOM SUCESSO', value: 'BOM SUCESSO' },
    { label: 'BONFIM', value: 'BONFIM' },
    { label: 'BONFINOPOLIS DE MINAS', value: 'BONFINOPOLIS DE MINAS' },
    { label: 'BORDA DA MATA', value: 'BORDA DA MATA' },
    { label: 'BOTELHOS', value: 'BOTELHOS' },
    { label: 'BRASILIA DE MINAS', value: 'BRASILIA DE MINAS' },
    { label: 'BRASOPOLIS', value: 'BRASOPOLIS' },
    { label: 'BRUMADINHO', value: 'BRUMADINHO' },
    { label: 'BUENO BRANDAO', value: 'BUENO BRANDAO' },
    { label: 'BUENOPOLIS', value: 'BUENOPOLIS' },
    { label: 'BURITIS', value: 'BURITIS' },
    { label: 'CABO VERDE', value: 'CABO VERDE' },
    { label: 'CACHOEIRA DE MINAS', value: 'CACHOEIRA DE MINAS' },
    { label: 'CAETE', value: 'CAETE' },
    { label: 'CALDAS', value: 'CALDAS' },
    { label: 'CAMANDUCAIA', value: 'CAMANDUCAIA' },
    { label: 'CAMBUI', value: 'CAMBUI' },
    { label: 'CAMBUQUIRA', value: 'CAMBUQUIRA' },
    { label: 'CAMPANHA', value: 'CAMPANHA' },
    { label: 'CAMPESTRE', value: 'CAMPESTRE' },
    { label: 'CAMPINA VERDE', value: 'CAMPINA VERDE' },
    { label: 'CAMPO BELO', value: 'CAMPO BELO' },
    { label: 'CAMPOS ALTOS', value: 'CAMPOS ALTOS' },
    { label: 'CAMPOS GERAIS', value: 'CAMPOS GERAIS' },
    { label: 'CANAPOLIS', value: 'CANAPOLIS' },
    { label: 'CANDEIAS', value: 'CANDEIAS' },
    { label: 'CAPELINHA', value: 'CAPELINHA' },
    { label: 'CAPINOPOLIS', value: 'CAPINOPOLIS' },
    { label: 'CARANDAI', value: 'CARANDAI' },
    { label: 'CARANGOLA', value: 'CARANGOLA' },
    { label: 'CARATINGA', value: 'CARATINGA' },
    { label: 'CARLOS CHAGAS', value: 'CARLOS CHAGAS' },
    { label: 'CARMO DA MATA', value: 'CARMO DA MATA' },
    { label: 'CARMO DE MINAS', value: 'CARMO DE MINAS' },
    { label: 'CARMO DO CAJURU', value: 'CARMO DO CAJURU' },
    { label: 'CARMO DO PARANAIBA', value: 'CARMO DO PARANAIBA' },
    { label: 'CARMO DO RIO CLARO', value: 'CARMO DO RIO CLARO' },
    { label: 'CARMOPOLIS DE MINAS', value: 'CARMOPOLIS DE MINAS' },
    { label: 'CASSIA', value: 'CASSIA' },
    { label: 'CATAGUASES', value: 'CATAGUASES' },
    { label: 'CAXAMBU', value: 'CAXAMBU' },
    { label: 'CLAUDIO', value: 'CLAUDIO' },
    { label: 'CONCEICAO DAS ALAGOAS', value: 'CONCEICAO DAS ALAGOAS' },
    { label: 'CONCEICAO DO MATO DENTRO', value: 'CONCEICAO DO MATO DENTRO' },
    { label: 'CONCEICAO DO RIO VERDE', value: 'CONCEICAO DO RIO VERDE' },
    { label: 'CONGONHAS', value: 'CONGONHAS' },
    { label: 'CONQUISTA', value: 'CONQUISTA' },
    { label: 'CONSELHEIRO LAFAIETE', value: 'CONSELHEIRO LAFAIETE' },
    { label: 'CONSELHEIRO PENA', value: 'CONSELHEIRO PENA' },
    { label: 'CONTAGEM', value: 'CONTAGEM' },
    { label: 'CORACAO DE JESUS', value: 'CORACAO DE JESUS' },
    { label: 'CORINTO', value: 'CORINTO' },
    { label: 'COROMANDEL', value: 'COROMANDEL' },
    { label: 'CORONEL FABRICIANO', value: 'CORONEL FABRICIANO' },
    { label: 'CRISTINA', value: 'CRISTINA' },
    { label: 'CRUZILIA', value: 'CRUZILIA' },
    { label: 'CURVELO', value: 'CURVELO' },
    { label: 'DIAMANTINA', value: 'DIAMANTINA' },
    { label: 'DIVINO', value: 'DIVINO' },
    { label: 'DIVINOPOLIS', value: 'DIVINOPOLIS' },
    { label: 'DORES DO INDAIA', value: 'DORES DO INDAIA' },
    { label: 'ELOI MENDES', value: 'ELOI MENDES' },
    { label: 'ENTRE RIOS DE MINAS', value: 'ENTRE RIOS DE MINAS' },
    { label: 'ERVALIA', value: 'ERVALIA' },
    { label: 'ESMERALDAS', value: 'ESMERALDAS' },
    { label: 'ESPERA FELIZ', value: 'ESPERA FELIZ' },
    { label: 'ESPINOSA', value: 'ESPINOSA' },
    { label: 'ESTRELA DO SUL', value: 'ESTRELA DO SUL' },
    { label: 'EUGENOPOLIS', value: 'EUGENOPOLIS' },
    { label: 'EXTREMA', value: 'EXTREMA' },
    { label: 'FERROS', value: 'FERROS' },
    { label: 'FORMIGA', value: 'FORMIGA' },
    { label: 'FRANCISCO SA', value: 'FRANCISCO SA' },
    { label: 'FRUTAL', value: 'FRUTAL' },
    { label: 'GALILEIA', value: 'GALILEIA' },
    { label: 'GOVERNADOR VALADARES', value: 'GOVERNADOR VALADARES' },
    { label: 'GRAO MOGOL', value: 'GRAO MOGOL' },
    { label: 'GUANHAES', value: 'GUANHAES' },
    { label: 'GUAPE', value: 'GUAPE' },
    { label: 'GUARANESIA', value: 'GUARANESIA' },
    { label: 'GUARANI', value: 'GUARANI' },
    { label: 'GUAXUPE', value: 'GUAXUPE' },
    { label: 'IBIA', value: 'IBIA' },
    { label: 'IBIRACI', value: 'IBIRACI' },
    { label: 'IBIRITE', value: 'IBIRITE' },
    { label: 'IGARAPE', value: 'IGARAPE' },
    { label: 'IGUATAMA', value: 'IGUATAMA' },
    { label: 'INHAPIM', value: 'INHAPIM' },
    { label: 'IPANEMA', value: 'IPANEMA' },
    { label: 'IPATINGA', value: 'IPATINGA' },
    { label: 'ITABIRA', value: 'ITABIRA' },
    { label: 'ITABIRITO', value: 'ITABIRITO' },
    { label: 'ITAGUARA', value: 'ITAGUARA' },
    { label: 'ITAJUBA', value: 'ITAJUBA' },
    { label: 'ITAMARANDIBA', value: 'ITAMARANDIBA' },
    { label: 'ITAMBACURI', value: 'ITAMBACURI' },
    { label: 'ITAMOGI', value: 'ITAMOGI' },
    { label: 'ITAMONTE', value: 'ITAMONTE' },
    { label: 'ITANHANDU', value: 'ITANHANDU' },
    { label: 'ITANHOMI', value: 'ITANHOMI' },
    { label: 'ITAPAGIPE', value: 'ITAPAGIPE' },
    { label: 'ITAPECERICA', value: 'ITAPECERICA' },
    { label: 'ITAUNA', value: 'ITAUNA' },
    { label: 'ITUIUTABA', value: 'ITUIUTABA' },
    { label: 'ITUMIRIM', value: 'ITUMIRIM' },
    { label: 'ITURAMA', value: 'ITURAMA' },
    { label: 'JABOTICATUBAS', value: 'JABOTICATUBAS' },
    { label: 'JACINTO', value: 'JACINTO' },
    { label: 'JACUI', value: 'JACUI' },
    { label: 'JACUTINGA', value: 'JACUTINGA' },
    { label: 'JANAUBA', value: 'JANAUBA' },
    { label: 'JANUARIA', value: 'JANUARIA' },
    { label: 'JEQUERI', value: 'JEQUERI' },
    { label: 'JEQUITINHONHA', value: 'JEQUITINHONHA' },
    { label: 'JOAO MONLEVADE', value: 'JOAO MONLEVADE' },
    { label: 'JOAO PINHEIRO', value: 'JOAO PINHEIRO' },
    { label: 'JUIZ DE FORA', value: 'JUIZ DE FORA' },
    { label: 'LAGOA DA PRATA', value: 'LAGOA DA PRATA' },
    { label: 'LAGOA SANTA', value: 'LAGOA SANTA' },
    { label: 'LAJINHA', value: 'LAJINHA' },
    { label: 'LAMBARI', value: 'LAMBARI' },
    { label: 'LAVRAS', value: 'LAVRAS' },
    { label: 'LEOPOLDINA', value: 'LEOPOLDINA' },
    { label: 'LIMA DUARTE', value: 'LIMA DUARTE' },
    { label: 'LUZ', value: 'LUZ' },
    { label: 'MACHADO', value: 'MACHADO' },
    { label: 'MALACACHETA', value: 'MALACACHETA' },
    { label: 'MANGA', value: 'MANGA' },
    { label: 'MANHUACU', value: 'MANHUACU' },
    { label: 'MANHUMIRIM', value: 'MANHUMIRIM' },
    { label: 'MANTENA', value: 'MANTENA' },
    { label: 'MAR DE ESPANHA', value: 'MAR DE ESPANHA' },
    { label: 'MARIANA', value: 'MARIANA' },
    { label: 'MARTINHO CAMPOS', value: 'MARTINHO CAMPOS' },
    { label: 'MATEUS LEME', value: 'MATEUS LEME' },
    { label: 'MATIAS BARBOSA', value: 'MATIAS BARBOSA' },
    { label: 'MATOZINHOS', value: 'MATOZINHOS' },
    { label: 'MEDINA', value: 'MEDINA' },
    { label: 'MERCES', value: 'MERCES' },
    { label: 'MESQUITA', value: 'MESQUITA' },
    { label: 'MINAS NOVAS', value: 'MINAS NOVAS' },
    { label: 'MIRADOURO', value: 'MIRADOURO' },
    { label: 'MIRAI', value: 'MIRAI' },
    { label: 'MONTALVANIA', value: 'MONTALVANIA' },
    { label: 'MONTE ALEGRE DE MINAS', value: 'MONTE ALEGRE DE MINAS' },
    { label: 'MONTE AZUL', value: 'MONTE AZUL' },
    { label: 'MONTE BELO', value: 'MONTE BELO' },
    { label: 'MONTE CARMELO', value: 'MONTE CARMELO' },
    { label: 'MONTE SANTO DE MINAS', value: 'MONTE SANTO DE MINAS' },
    { label: 'MONTE SIAO', value: 'MONTE SIAO' },
    { label: 'MONTES CLAROS', value: 'MONTES CLAROS' },
    { label: 'MORADA NOVA DE MINAS', value: 'MORADA NOVA DE MINAS' },
    { label: 'MURIAE', value: 'MURIAE' },
    { label: 'MUTUM', value: 'MUTUM' },
    { label: 'MUZAMBINHO', value: 'MUZAMBINHO' },
    { label: 'NANUQUE', value: 'NANUQUE' },
    { label: 'NATERCIA', value: 'NATERCIA' },
    { label: 'NEPOMUCENO', value: 'NEPOMUCENO' },
    { label: 'NOVA ERA', value: 'NOVA ERA' },
    { label: 'NOVA LIMA', value: 'NOVA LIMA' },
    { label: 'NOVA PONTE', value: 'NOVA PONTE' },
    { label: 'NOVA RESENDE', value: 'NOVA RESENDE' },
    { label: 'NOVA SERRANA', value: 'NOVA SERRANA' },
    { label: 'NOVO CRUZEIRO', value: 'NOVO CRUZEIRO' },
    { label: 'OLIVEIRA', value: 'OLIVEIRA' },
    { label: 'OURO BRANCO', value: 'OURO BRANCO' },
    { label: 'OURO FINO', value: 'OURO FINO' },
    { label: 'OURO PRETO', value: 'OURO PRETO' },
    { label: 'PALMA', value: 'PALMA' },
    { label: 'PARA DE MINAS', value: 'PARA DE MINAS' },
    { label: 'PARACATU', value: 'PARACATU' },
    { label: 'PARAGUACU', value: 'PARAGUACU' },
    { label: 'PARAISOPOLIS', value: 'PARAISOPOLIS' },
    { label: 'PARAOPEBA', value: 'PARAOPEBA' },
    { label: 'PASSA QUATRO', value: 'PASSA QUATRO' },
    { label: 'PASSA TEMPO', value: 'PASSA TEMPO' },
    { label: 'PASSOS', value: 'PASSOS' },
    { label: 'PATOS DE MINAS', value: 'PATOS DE MINAS' },
    { label: 'PATROCINIO', value: 'PATROCINIO' },
    { label: 'PECANHA', value: 'PECANHA' },
    { label: 'PEDRA AZUL', value: 'PEDRA AZUL' },
    { label: 'PEDRALVA', value: 'PEDRALVA' },
    { label: 'PEDRO LEOPOLDO', value: 'PEDRO LEOPOLDO' },
    { label: 'PERDIZES', value: 'PERDIZES' },
    { label: 'PERDOES', value: 'PERDOES' },
    { label: 'PIRANGA', value: 'PIRANGA' },
    { label: 'PIRAPETINGA', value: 'PIRAPETINGA' },
    { label: 'PIRAPORA', value: 'PIRAPORA' },
    { label: 'PITANGUI', value: 'PITANGUI' },
    { label: 'PIUMHI', value: 'PIUMHI' },
    { label: 'POCO FUNDO', value: 'POCO FUNDO' },
    { label: 'POCOS DE CALDAS', value: 'POCOS DE CALDAS' },
    { label: 'POMPEU', value: 'POMPEU' },
    { label: 'PONTE NOVA', value: 'PONTE NOVA' },
    { label: 'PORTEIRINHA', value: 'PORTEIRINHA' },
    { label: 'POUSO ALEGRE', value: 'POUSO ALEGRE' },
    { label: 'PRADOS', value: 'PRADOS' },
    { label: 'PRATA', value: 'PRATA' },
    { label: 'PRATAPOLIS', value: 'PRATAPOLIS' },
    { label: 'PRESIDENTE OLEGARIO', value: 'PRESIDENTE OLEGARIO' },
    { label: 'RAUL SOARES', value: 'RAUL SOARES' },
    { label: 'RESENDE COSTA', value: 'RESENDE COSTA' },
    { label: 'RESPLENDOR', value: 'RESPLENDOR' },
    { label: 'RIBEIRAO DAS NEVES', value: 'RIBEIRAO DAS NEVES' },
    { label: 'RIO CASCA', value: 'RIO CASCA' },
    { label: 'RIO NOVO', value: 'RIO NOVO' },
    { label: 'RIO PARANAIBA', value: 'RIO PARANAIBA' },
    { label: 'RIO PARDO DE MINAS', value: 'RIO PARDO DE MINAS' },
    { label: 'RIO PIRACICABA', value: 'RIO PIRACICABA' },
    { label: 'RIO POMBA', value: 'RIO POMBA' },
    { label: 'RIO PRETO', value: 'RIO PRETO' },
    { label: 'RIO VERMELHO', value: 'RIO VERMELHO' },
    { label: 'SABARA', value: 'SABARA' },
    { label: 'SABINOPOLIS', value: 'SABINOPOLIS' },
    { label: 'SACRAMENTO', value: 'SACRAMENTO' },
    { label: 'SALINAS', value: 'SALINAS' },
    { label: 'SANTA BARBARA', value: 'SANTA BARBARA' },
    { label: 'SANTA LUZIA', value: 'SANTA LUZIA' },
    { label: 'SANTA MARIA DO SUACUI', value: 'SANTA MARIA DO SUACUI' },
    { label: 'SANTA RITA DE CALDAS', value: 'SANTA RITA DE CALDAS' },
    { label: 'SANTA RITA DO SAPUCAI', value: 'SANTA RITA DO SAPUCAI' },
    { label: 'SANTA VITORIA', value: 'SANTA VITORIA' },
    { label: 'SANTO ANTONIO DO MONTE', value: 'SANTO ANTONIO DO MONTE' },
    { label: 'SANTOS DUMONT', value: 'SANTOS DUMONT' },
    { label: 'SAO DOMINGOS DO PRATA', value: 'SAO DOMINGOS DO PRATA' },
    { label: 'SAO FRANCISCO', value: 'SAO FRANCISCO' },
    { label: 'SAO GONCALO DO SAPUCAI', value: 'SAO GONCALO DO SAPUCAI' },
    { label: 'SAO GOTARDO', value: 'SAO GOTARDO' },
    { label: 'SAO JOAO DA PONTE', value: 'SAO JOAO DA PONTE' },
    { label: 'SAO JOAO DEL REI', value: 'SAO JOAO DEL REI' },
    { label: 'SAO JOAO DO PARAISO', value: 'SAO JOAO DO PARAISO' },
    { label: 'SAO JOAO EVANGELISTA', value: 'SAO JOAO EVANGELISTA' },
    { label: 'SAO JOAO NEPOMUCENO', value: 'SAO JOAO NEPOMUCENO' },
    { label: 'SAO LOURENCO', value: 'SAO LOURENCO' },
    { label: 'SAO ROMAO', value: 'SAO ROMAO' },
    { label: 'SAO ROQUE DE MINAS', value: 'SAO ROQUE DE MINAS' },
    { label: 'SAO SEBASTIAO DO PARAISO', value: 'SAO SEBASTIAO DO PARAISO' },
    { label: 'SENADOR FIRMINO', value: 'SENADOR FIRMINO' },
    { label: 'SERRO', value: 'SERRO' },
    { label: 'SETE LAGOAS', value: 'SETE LAGOAS' },
    { label: 'SILVIANOPOLIS', value: 'SILVIANOPOLIS' },
    { label: 'TAIOBEIRAS', value: 'TAIOBEIRAS' },
    { label: 'TARUMIRIM', value: 'TARUMIRIM' },
    { label: 'TEIXEIRAS', value: 'TEIXEIRAS' },
    { label: 'TEOFILO OTONI', value: 'TEOFILO OTONI' },
    { label: 'TIMOTEO', value: 'TIMOTEO' },
    { label: 'TIROS', value: 'TIROS' },
    { label: 'TOMBOS', value: 'TOMBOS' },
    { label: 'TRES CORACOES', value: 'TRES CORACOES' },
    { label: 'TRES MARIAS', value: 'TRES MARIAS' },
    { label: 'TRES PONTAS', value: 'TRES PONTAS' },
    { label: 'TUPACIGUARA', value: 'TUPACIGUARA' },
    { label: 'TURMALINA', value: 'TURMALINA' },
    { label: 'UBA', value: 'UBA' },
    { label: 'UBERABA', value: 'UBERABA' },
    { label: 'UBERLANDIA', value: 'UBERLANDIA' },
    { label: 'UNAI', value: 'UNAI' },
    { label: 'VARGINHA', value: 'VARGINHA' },
    { label: 'VARZEA DA PALMA', value: 'VARZEA DA PALMA' },
    { label: 'VAZANTE', value: 'VAZANTE' },
    { label: 'VESPASIANO', value: 'VESPASIANO' },
    { label: 'VICOSA', value: 'VICOSA' },
    { label: 'VIRGINOPOLIS', value: 'VIRGINOPOLIS' },
    { label: 'VISCONDE DO RIO BRANCO', value: 'VISCONDE DO RIO BRANCO' },

];

export const regionsSelect = [
    { label: 'CENTRAL', value: 'CENTRAL' },
    { label: 'REGIAO ADMINISTRATIVA I', value: 'REGIAO ADMINISTRATIVA I' },
    { label: 'REGIAO ADMINISTRATIVA II', value: 'REGIAO ADMINISTRATIVA II' },
    { label: 'REGIAO ADMINISTRATIVA III', value: 'REGIAO ADMINISTRATIVA III' },
    { label: 'REGIAO ADMINISTRATIVA IV', value: 'REGIAO ADMINISTRATIVA IV' },
    { label: 'REGIAO ADMINISTRATIVA V', value: 'REGIAO ADMINISTRATIVA V' },
    { label: 'REGIAO ADMINISTRATIVA VI', value: 'REGIAO ADMINISTRATIVA VI' },
    { label: 'REGIAO ADMINISTRATIVA VII', value: 'REGIAO ADMINISTRATIVA VII' },
    { label: 'REGIAO ADMINISTRATIVA VIII', value: 'REGIAO ADMINISTRATIVA VIII' },
    { label: 'REGIAO ADMINISTRATIVA IX', value: 'REGIAO ADMINISTRATIVA IX' },
    { label: 'REGIAO ADMINISTRATIVA X', value: 'REGIAO ADMINISTRATIVA X' },
    { label: 'REGIAO ADMINISTRATIVA XI', value: 'REGIAO ADMINISTRATIVA XI' },
    { label: 'REGIAO ADMINISTRATIVA XII', value: 'REGIAO ADMINISTRATIVA XII' },
    { label: 'REGIAO ADMINISTRATIVA XIII', value: 'REGIAO ADMINISTRATIVA XIII' },
    { label: 'REGIAO ADMINISTRATIVA XIV', value: 'REGIAO ADMINISTRATIVA XIV' },
    { label: 'REGIAO ADMINISTRATIVA XV', value: 'REGIAO ADMINISTRATIVA XV' },
    { label: 'REGIAO ADMINISTRATIVA XVI', value: 'REGIAO ADMINISTRATIVA XVI' },
    { label: 'REGIAO ADMINISTRATIVA XVII', value: 'REGIAO ADMINISTRATIVA XVII' },
    { label: 'REGIAO ADMINISTRATIVA XVIII', value: 'REGIAO ADMINISTRATIVA XVIII' },
    { label: 'REGIAO ADMINISTRATIVA XIX', value: 'REGIAO ADMINISTRATIVA XIX' },
    { label: 'REGIAO ADMINISTRATIVA XX', value: 'REGIAO ADMINISTRATIVA XX' },
    { label: 'REGIAO ADMINISTRATIVA XXI', value: 'REGIAO ADMINISTRATIVA XXI' },
    { label: 'REGIAO ADMINISTRATIVA XXII', value: 'REGIAO ADMINISTRATIVA XXII' },
    { label: 'REGIAO ADMINISTRATIVA XXIII', value: 'REGIAO ADMINISTRATIVA XXIII' },
    { label: 'REGIAO ADMINISTRATIVA XXIV', value: 'REGIAO ADMINISTRATIVA XXIV' },
    { label: 'REGIAO ADMINISTRATIVA XXV', value: 'REGIAO ADMINISTRATIVA XXV' },
    { label: 'REGIAO ADMINISTRATIVA XXVI', value: 'REGIAO ADMINISTRATIVA XXVI' },
    { label: 'REGIAO ADMINISTRATIVA XXVII', value: 'REGIAO ADMINISTRATIVA XXVII' },
    { label: 'REGIAO ADMINISTRATIVA XXVIII', value: 'REGIAO ADMINISTRATIVA XXVIII' },
    { label: 'REGIAO ADMINISTRATIVA XXIX', value: 'REGIAO ADMINISTRATIVA XXIX' },
    { label: 'REGIAO ADMINISTRATIVA XXX', value: 'REGIAO ADMINISTRATIVA XXX' },
    { label: 'REGIAO ADMINISTRATIVA XXXI', value: 'REGIAO ADMINISTRATIVA XXXI' },
    { label: 'REGIAO ADMINISTRATIVA XXXII', value: 'REGIAO ADMINISTRATIVA XXXII' },
    { label: 'REGIAO ADMINISTRATIVA XXXIII', value: 'REGIAO ADMINISTRATIVA XXXIII' },
    { label: 'REGIAO ADMINISTRATIVA XXXIV', value: 'REGIAO ADMINISTRATIVA XXXIV' },
    { label: 'REGIAO ADMINISTRATIVA XXXV', value: 'REGIAO ADMINISTRATIVA XXXV' },
    { label: 'REGIAO ADMINISTRATIVA XXXVI', value: 'REGIAO ADMINISTRATIVA XXXVI' },
    { label: 'REGIAO ADMINISTRATIVA XXXVII', value: 'REGIAO ADMINISTRATIVA XXXVII' },
    { label: 'REGIAO ADMINISTRATIVA XXXVIII', value: 'REGIAO ADMINISTRATIVA XXXVIII' },
    { label: 'REGIAO ADMINISTRATIVA XXXIX', value: 'REGIAO ADMINISTRATIVA XXXIX' },
    { label: 'REGIAO ADMINISTRATIVA XL', value: 'REGIAO ADMINISTRATIVA XL' },
    { label: 'REGIAO ADMINISTRATIVA XLI', value: 'REGIAO ADMINISTRATIVA XLI' },
    { label: 'REGIAO ADMINISTRATIVA XLII', value: 'REGIAO ADMINISTRATIVA XLII' },
    { label: 'REGIAO ADMINISTRATIVA XLIII', value: 'REGIAO ADMINISTRATIVA XLIII' },
    { label: 'REGIAO ADMINISTRATIVA XLIV', value: 'REGIAO ADMINISTRATIVA XLIV' },
    { label: 'REGIAO ADMINISTRATIVA XLV', value: 'REGIAO ADMINISTRATIVA XLV' },
    { label: 'REGIAO ADMINISTRATIVA XLVI', value: 'REGIAO ADMINISTRATIVA XLVI' },
    { label: 'REGIAO ADMINISTRATIVA XLVII', value: 'REGIAO ADMINISTRATIVA XLVII' },
];